import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Http, Headers, RequestOptions, RequestMethod } from '@angular/http';
import * as CryptoJS from 'crypto-js';
import "rxjs/add/operator/map";

//Service Encryption 
import {EncryptionService} from '../services/encryption.service';

  
@Injectable()
export class MysqlService {

constructor(public http: Http,public encryptme:EncryptionService) { }
 
public fetchDataV2(mysql:string): Observable<any> {

    //Create Spinner
    //this.presentLoading();

    //Create Headers for POST
      var headers = new Headers();
      headers.append("Accept", 'application/pdf');
      headers.append('Content-Type', 'application/json' );
      headers.append('Access-Control-Allow-Origin', '*' ); 
      const requestOptions = new RequestOptions({ headers: headers });
      //console.log(mysql);

    // if (mysql.length<10){
    //   mysql= 'select * from ' + mysql;
    //   //console.log(mysql);
    // }

    //Generate Form to Post 
    let postData = new FormData();
      postData.append('data',this.encryptme.encrytme(mysql));

    //Site to post data to 
    return this.http.post("https://www.vitu.site/goSql.php", postData)
    // Previous link: https://dev-x.co.za/MayapurIT/Goshala/cowdb1.php
  }

}


// WEBPACK FOOTER //
// ./src/services/mysql.service.ts